import { render, staticRenderFns } from "./DashboardDevices.vue?vue&type=template&id=680fd982&scoped=true"
import script from "./DashboardDevices.vue?vue&type=script&lang=js"
export * from "./DashboardDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680fd982",
  null
  
)

export default component.exports